(() => {
  'use strict';
  if (window.primaCartDrawerUI) return;
  window.primaCartDrawerUI = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const homes = new WeakMap();
  const selector = '.nnom-drawer-upsells-mobile,[data-nnom-cart-rewards],.cart-drawer__savings';
  let queued = false;

  function relocate(node, parent, after) {
    const dialog = node.querySelector('dialog[open]');
    const focus = dialog && dialog.contains(document.activeElement) ? document.activeElement : null;
    if (dialog) dialog.close();
    if (after) after.after(node); else parent.appendChild(node);
    if (dialog && dialog.isConnected) {
      try { dialog.showModal(); if (focus) focus.focus({ preventScroll: true }); } catch {}
    }
  }

  function remember(node) {
    if (homes.has(node)) return;
    const marker = document.createComment('Prima drawer original position');
    node.before(marker);
    homes.set(node, marker);
  }

  function layout() {
    queued = false;
    document.querySelectorAll('cart-drawer').forEach(drawer => {
      const inner = drawer.querySelector('.drawer__inner');
      const scroller = inner && inner.querySelector('cart-drawer-items');
      if (!inner || !scroller || drawer.classList.contains('is-empty')) return;
      const freshRewards = inner.querySelector('.cart-drawer__footer [data-nnom-cart-rewards]');
      const movedRewards = Array.from(scroller.children).find(node => node.matches('[data-nnom-cart-rewards]'));
      const freshSavings = inner.querySelector('.drawer__footer .cart-drawer__savings');
      const movedSavings = Array.from(scroller.children).find(node => node.matches('.cart-drawer__savings'));
      if (freshRewards && movedRewards && freshRewards !== movedRewards) {
        const oldDialog = movedRewards.querySelector('dialog[open]');
        if (oldDialog) oldDialog.close();
        movedRewards.remove();
      }
      if (freshSavings && movedSavings && freshSavings !== movedSavings) movedSavings.remove();
      if (!mobile.matches) {
        inner.querySelectorAll(selector).forEach(node => {
          const marker = homes.get(node);
          if (marker && marker.isConnected) {
            relocate(node, marker.parentNode, marker);
            marker.remove(); homes.delete(node);
          }
        });
        return;
      }
      const upsells = inner.querySelector('.nnom-drawer-upsells-mobile');
      const rewards = freshRewards || movedRewards;
      const savings = freshSavings || movedSavings;
      [upsells, rewards, savings].forEach(node => {
        if (!node || node.parentElement === scroller) return;
        remember(node);
        relocate(node, scroller);
      });
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(layout);
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const openButton = target.closest('[data-nnom-upsells-open]');
    if (openButton) {
      const dialog = openButton.closest('.nnom-drawer-upsells-mobile').querySelector('[data-nnom-upsells-dialog]');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const closeButton = target.closest('[data-nnom-upsells-close]');
    if (closeButton) {
      const dialog = closeButton.closest('[data-nnom-upsells-dialog]');
      if (dialog && dialog.open) dialog.close();
      return;
    }

    const dialog = target.closest('[data-nnom-upsells-dialog]');
    if (dialog && target === dialog) dialog.close();
  });

  function start() {
    layout();
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches('cart-drawer,.drawer__inner,cart-drawer-items,' + selector) ||
          node.querySelector('cart-drawer,.drawer__inner,cart-drawer-items,' + selector))))) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    if (mobile.addEventListener) mobile.addEventListener('change', schedule);
    else mobile.addListener(schedule);
    window.addEventListener('pageshow', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
